var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { APP_CONFIG } from "../config/runtime-config";
const DEBUG_PREFIX = "[USE-AUTH]";
const AUTH_SCOPE = APP_CONFIG.AUTH_SCOPE;
const defaultScopes = (AUTH_SCOPE ? [AUTH_SCOPE] : ["User.Read", "openid", "profile", "offline_access"]);
export function useAuth() {
    var _a;
    const { instance, accounts, inProgress } = useMsal();
    const account = (_a = accounts === null || accounts === void 0 ? void 0 : accounts[0]) !== null && _a !== void 0 ? _a : null;
    const login = () => __awaiter(this, void 0, void 0, function* () {
        const isMobile = typeof window !== "undefined" && window.matchMedia && window.matchMedia("(max-width: 768px)").matches;
        try {
            const req = { scopes: defaultScopes };
            if (isMobile) {
                yield instance.loginRedirect(req);
            }
            else {
                yield instance.loginPopup(req);
                // After popup success, ensure navigation to the intended target
                try {
                    const target = (typeof sessionStorage !== "undefined" && sessionStorage.getItem("postLoginRedirect")) || "/project";
                    if (typeof window !== "undefined")
                        window.location.assign(target);
                }
                catch (_a) { }
            }
        }
        catch (e) {
            console.error(DEBUG_PREFIX, "Login failed:", e);
            // As a fallback, try redirect if popup blocked
            try {
                yield instance.loginRedirect({ scopes: defaultScopes });
            }
            catch (_b) { }
        }
    });
    const logout = () => __awaiter(this, void 0, void 0, function* () {
        // Hard local sign-out: clear storage and navigate to /login without showing any dialog
        try {
            if (typeof window !== "undefined") {
                try {
                    window.localStorage.clear();
                }
                catch (_a) { }
                try {
                    window.sessionStorage.clear();
                }
                catch (_b) { }
                try {
                    const cookies = document.cookie ? document.cookie.split(";") : [];
                    cookies.forEach((c) => {
                        const name = c.split("=")[0].trim();
                        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
                    });
                }
                catch (_c) { }
            }
        }
        finally {
            if (typeof window !== "undefined") {
                try {
                    window.location.replace("/login");
                }
                catch ( /* noop */_d) { /* noop */ }
            }
        }
    });
    const getToken = (...args_1) => __awaiter(this, [...args_1], void 0, function* (scopes = defaultScopes) {
        if (!account) {
            console.warn(DEBUG_PREFIX, "getToken: No account available");
            return null;
        }
        try {
            const res = yield instance.acquireTokenSilent({ account, scopes });
            return res.accessToken || null;
        }
        catch (err) {
            console.error(DEBUG_PREFIX, "getToken: Silent acquisition failed:", err);
            if (err instanceof InteractionRequiredAuthError) {
                try {
                    const res = yield instance.acquireTokenPopup({ account, scopes });
                    return res.accessToken || null;
                }
                catch (_a) {
                    console.warn(DEBUG_PREFIX, "getToken: Popup failed, trying redirect");
                    try {
                        yield instance.acquireTokenRedirect({ account: account !== null && account !== void 0 ? account : undefined, scopes });
                    }
                    catch (_b) {
                        /* noop */
                    }
                }
            }
            return null;
        }
    });
    return {
        instance,
        account,
        isAuthenticated: !!account,
        login,
        logout,
        inProgress,
        getToken,
    };
}
